import styled from 'styled-components';

export const NotificationContainer = styled.div`
  position: absolute;
  display: flex;
  z-index: 3;
  left: 50%;
  vertical-align: middle;
  text-align: center;
  height: 50px;
  padding: 0 15px;
  align-items: center;
  white-space: nowrap;
  background-color: ${({ theme }) => theme.colors.defaultNavy};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 3px;
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  bottom: 0;
  transform: translate(
    -50%,
    ${({ isVisible }) => (isVisible ? '-20px' : '50px')}
  );
  transition: transform 180ms ease-in-out;
`;
